import React from 'react';
import { Spinner } from 'reactstrap';

const LoadingSpinner = (props) => {
  return (
    <div>
      <Spinner color="primary" />
    </div>
  );
}

export default LoadingSpinner;